import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
  Platform,
  Alert,
  FlatList,
  TouchableWithoutFeedback,
  Dimensions,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import {
  styleSheet,
  colors,
  sizes,
  HEIGHT,
  CHILD_RATIO,
  PARENT_RATIO,
} from "app/utils/styleSheet";
import Hoverable from "app/components/Hoverable";

// let WIDTH = Dimensions.get("window").width;

import MomentBullet from "app/components/chapter/MomentBullet";
import HoverableTooltip from "app/components/HoverableTooltip";

import {
  Ionicons,
  Feather,
  AntDesign,
  FontAwesome,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import store from "app/redux/store";
import { progress, create } from "app/actions/values";

import { StyleContext } from "app/contexts/Style";

export default class MomentTimeline extends React.Component {
  static contextType = StyleContext;
  DOT_SIZE = 10;
  DOT_PADDING = 2;
  MAX_DOTS_PER_BUCKET = 6;
  constructor(props) {
    super(props);

    this.state = {
      recursive: false,
      descendantLevelsDeep: 1,
      // pastRevisions: false,
      events: [],
      startAt: null,
      endAt: null,
      range: 0,
      key: 0,
      slots: [],
      expandedDates: [],
      zoomedOut: true,
      fineZooming: 0,
      loadingRevisions: false,
      averageSpan: "-",
      allRevisions: false,
      showChapters: false,
      chapterSlots: [],
      showPropagatedProgress: true,
      showCreations: true,
    };
  }

  componentDidMount = () => {
    this.generateSlots();
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.allRevisions != this.props.allRevisions ||
      !textHelpers.compareObjects(prevProps.value, this.props.value)
    ) {
      this.generateSlots();
    }
  };

  generateSlots = async () => {
    let { value, allRevisions } = this.props;
    // let { value, events } = this.props;
    let { recursive, key, showPropagatedProgress, showCreations } = this.state;
    // let { allRevisions } = this.state;

    // if (allRevisions) value = valueHelpers.condenseRevisions(value);

    let timelineOpts = { includeChildCreations: showCreations };
    let events = valueHelpers.getTimeline(value, recursive, 0, {}, timelineOpts);
    if (allRevisions) {
      let revisions = valueHelpers.getRevisions(value);
      for (let r of revisions) {
        events = [
          ...events,
          ...valueHelpers.getTimeline(r, recursive, 0, {}, timelineOpts),
        ];
      }
    }
    events = textHelpers.uniq(events, "event_id");
    events = textHelpers.oldestFirst(events, "timestamp");

    if (!showPropagatedProgress)
      events = events.filter((e) => e.category != "progress");

    // events = events.reverse();
    console.log("timeline events:", events);

    let { slots, startAt, endAt, range, averageSpan } =
      this.formatSlots(events);

    !!this.props.setEvents && this.props.setEvents(events);
    this.setState({
      events,
      startAt,
      endAt,
      range,
      slots,
      averageSpan,
      // key: key + 1,
    });
  };

  formatSlots = (events) => {
    let { value } = this.props;

    let startAt = value.created_at;
    if (!!events?.length) {
      let firstEvent = events[0];
      let eStartAt = firstEvent.timestamp;
      if (!startAt || eStartAt < startAt) startAt = eStartAt;
      // startAt = timeHelpers.beginningOfMonth(startAt);
    }
    startAt = timeHelpers.dateTimeToDate(startAt);

    let endAt = value.completed_at || new Date();
    if (!!events?.length) {
      let lastEvent = events[events.length - 1];
      let eEndAt = lastEvent.timestamp;
      if (!endAt || eEndAt > endAt) endAt = eEndAt;
    }
    endAt = timeHelpers.dateTimeToDate(endAt);

    let range = Math.ceil(timeHelpers.daysAgo(startAt, endAt));

    if (range < 6) {
      let diff = 6 - range;
      let startAtDiff = Math.floor(diff / 2);
      let endAtDiff = Math.ceil(diff / 2);
      startAt = timeHelpers.tomorrow(startAt, -startAtDiff);
      startAt = timeHelpers.dateTimeToDate(startAt);
      endAt = timeHelpers.tomorrow(endAt, -endAtDiff);
      endAt = timeHelpers.dateTimeToDate(endAt);
      range = 6;
    }

    let gaps = [];
    let lastEventDay = null;

    let slots = [];

    let minCushionDays = 4;
    let badgeWidth = this.context.sizes.base * 1.2;
    let slotWidth = this.context.sizes.WIDTH / range;
    if (slotWidth < badgeWidth) {
      minCushionDays *= Math.ceil(badgeWidth / slotWidth);
    }

    let cushionDays = Math.min(minCushionDays, Math.floor(range / 7)); // 1 day for each 1 week

    let start = 0 - cushionDays;
    let end = range + cushionDays;
    for (let i = start; i <= end; i++) {
      let slotDate = timeHelpers.tomorrow(startAt, i);
      slotDate = timeHelpers.dateTimeToDate(slotDate);
      let dateEvents = events.filter((ev) => {
        // let evTs = ev.completed_at || ev.created_at;
        let evTs = ev.timestamp;
        let evDate = timeHelpers.dateTimeToDate(evTs);
        if (evDate == slotDate) {
          return true;
        } else {
          return false;
        }
      });
      if (!!dateEvents.length) {
        if (!!lastEventDay) {
          gaps.push(timeHelpers.daysApart(slotDate, lastEventDay));
        }
        lastEventDay = slotDate;
      }
      slots.push({
        date: slotDate,
        events: dateEvents,
        cushion: i < 0 || i > range,
      });
    }
    // slots = slots.reverse(); // reverse if using the inverted FlatList
    // console.log("SLOTS", slots, events.length);
    let averageSpan = !gaps.length
      ? "n/a"
      : gaps.reduce((a, b) => a + b) / gaps.length;

    return { events, slots, startAt, endAt, range, averageSpan };
  };

  render() {
    let { value } = this.props;
    let {
      recursive,
      pastRevisions,
      events,
      startAt,
      endAt,
      range,
      slots,
      expandedDates,
      zoomedOut,
      fineZooming,
      loadingRevisions,
      fetchingInheritance,
      averageSpan,
      allRevisions,
      showChapters,
      descendantLevelsDeep,
      showPropagatedProgress,
      showCreations,
    } = this.state;

    let hasChildren = !!valueHelpers.getChildren({ value, includeNotes: true })
      .length;
    let hasRevisions = value.id != value.root_id;
    let allowZoom = slots.length * 20 > this.context.sizes.WIDTH;
    allowZoom = true;

    let progressiveEvents = events.filter(
      (e) => !["creation", "note", "archive"].includes(e.category),
    );

    return (
      <View
        style={[this.styles().contentRow]}
        ref={(r) => (this.rootRef = r)}
      >
        {this.renderTimelineOverlay()}
        <View style={this.styles().header}>
          <View style={this.styles().headerSection}>
            <Text
              bold
              onPress={() => {
                // WIDTH = Dimensions.get("window").width;
              }}
            >
              Timeline
            </Text>

            <Text> | </Text>

            <Text>{range} days</Text>

            <Text> | </Text>

            <Text>
              {progressiveEvents.length} event
              {progressiveEvents.length != 1 && "s"}
            </Text>
          </View>

          <View style={this.styles().headerSection}>
            {!!averageSpan && (
              <Text>{Math.round(averageSpan * 100) / 100} day cadence</Text>
            )}

            {!!value.frequency && (
              <Text>
                {!!averageSpan && ` / `}
                {value.frequency} day quota
              </Text>
            )}

            {!!value.frequency &&
              !!averageSpan &&
              (averageSpan < value.frequency ? (
                <Text
                  style={[
                    {
                      // color: "green",
                      // borderColor: "green",
                      backgroundColor: "green",
                      color: "white",
                      // borderWidth: 1,
                      paddingHorizontal: this.context.sizes.small,
                      width: this.context.sizes.bulletWidth,
                      height: this.context.sizes.bulletWidth,
                      borderRadius: 999,
                      marginLeft: this.context.sizes.small,
                    },
                  ]}
                >
                  ✓
                </Text>
              ) : (
                <Text
                  center
                  style={{
                    // color: "red",
                    // borderColor: "red",
                    backgroundColor: "red",
                    color: "white",
                    // borderWidth: 1,
                    paddingHorizontal: this.context.sizes.small,
                    width: this.context.sizes.bulletWidth,
                    height: this.context.sizes.bulletWidth,
                    borderRadius: 999,
                    marginLeft: this.context.sizes.small,
                  }}
                >
                  x
                </Text>
              ))}

            <Text> </Text>

            <Text
              checkboxButton
              button
              selectedButton={showPropagatedProgress}
              onPress={async () => {
                await this.setState({
                  showPropagatedProgress: !showPropagatedProgress,
                });
                this.generateSlots();
              }}
            >
              Propagated Progess
            </Text>

            <Text
              checkboxButton
              button
              selectedButton={showCreations}
              onPress={async () => {
                await this.setState({
                  showCreations: !showCreations,
                });
                this.generateSlots();
              }}
            >
              Creations
            </Text>

            {!!allowZoom && !fineZooming && (
              <HoverableTooltip text={"Long Press for fine tuning"}>
                <Text
                  button={!zoomedOut}
                  selectedButton={zoomedOut}
                  onPress={async () => {
                    // WIDTH = Dimensions.get("window").width;
                    await this.setState({ zoomedOut: !zoomedOut });
                  }}
                  onLongPress={() =>
                    this.setState({ fineZooming: 1, zoomedOut: false })
                  }
                >
                  {zoomedOut ? "Zoom in" : "Zoom out"}
                </Text>
              </HoverableTooltip>
            )}

            {!!fineZooming && (
              <Text
                button
                selectedButton={fineZooming == 100}
                onPress={async () => {
                  if (fineZooming == 100) {
                    this.setState({ fineZooming: 0, zoomedOut: true });
                  } else {
                    this.setState({
                      fineZooming: fineZooming == 1 ? 10 : fineZooming + 10,
                    });
                  }
                }}
                onLongPress={() => this.setState({ fineZooming: true })}
              >
                {fineZooming == 100 ? "Reset Zoom" : "Zoom More"} ({fineZooming}
                %)
              </Text>
            )}

            {!!hasChildren && value.id != "journal" && (
              <Text
                button={!recursive}
                selectedButton={recursive}
                onPress={async () => {
                  // WIDTH = Dimensions.get("window").width;
                  // await this.setState({ recursive: !recursive})
                  await this.setState({
                    recursive: true,
                    descendantLevelsDeep: descendantLevelsDeep + 1,
                  });
                  await this.fetchInheritance();
                  this.generateSlots();
                }}
              >
                {recursive
                  ? `Go Deeper (${descendantLevelsDeep})`
                  : "Show inherited"}{" "}
                {fetchingInheritance && <ActivityIndicator size="small" />}
              </Text>
            )}

            {!!this.props.onHide && (
              <Text button onPress={this.props.onHide}>
                Hide Timeline
              </Text>
            )}
            <Text
              button
              onPress={async () => {
                let newShowChapters = !showChapters;
                this.setState({
                  showChapters: newShowChapters,
                  loadingChapters: newShowChapters,
                });
                if (newShowChapters) {
                  let res = await valueActions.fetchMoments(value.id);
                  if (res.success) {
                    let moments = res.moments.map((m) => ({
                      ...m,
                      value,
                      timestamp: m.completed_at || m.created_at,
                    }));
                    let chapterSlots = this.formatSlots(moments).slots;
                    console.log("chapter slots", chapterSlots);
                    await this.setState({
                      loadingChapters: false,
                      chapterSlots,
                      moments,
                      chapters: res.chapters,
                      momentTimestamps: res.timestamps,
                    });
                  }
                }
              }}
            >
              {showChapters ? "Hide" : "Show"} Chapters
            </Text>
            <Text
              button
              selectedButton={allRevisions}
              onPress={async () => {
                await this.setState({
                  allRevisions: !allRevisions,
                  zoomedOut: !allRevisions,
                  fineZooming: 0,
                });
                this.generateSlots();
              }}
            >
              {allRevisions ? "Current Version" : "All Versions"}
            </Text>
          </View>

          {/*hasChildren && hasRevisions && <Text> | </Text>*/}
          {/*hasRevisions && (
            <Text
              onPress={async () => {
                await this.setState({
                  pastRevisions: !pastRevisions,
                  loadingRevisions: true,
                });
                await this.props.getRevisions();
                await this.setState({ loadingRevisions: false });
                this.generateSlots();
              }}
            >
              {pastRevisions ? "Only show current" : "Show all revisions"}
              {loadingRevisions && <ActivityIndicator sizel="small" />}
            </Text>
          )*/}
        </View>

        <View style={this.styles().timeline}>
          <Text trim>{startAt}</Text>
          {/*<View style={this.styles().line} />*/}
          <View style={{ flex: 1 }} />
          <Text trim>{endAt}</Text>
        </View>

        <ScrollView
          ref={(r) => (this.scrollRef = r)}
          horizontal
          style={{
            width: this.context.sizes.WIDTH,
            maxHeight: showChapters ? 400 : 200,
            flex: 1,
          }}
          contentContainerStyle={{
            flexGrow: 1,
            flexDirection: "column",
            width:
              zoomedOut && !fineZooming ? this.context.sizes.WIDTH : undefined,
          }}
        >
          {showChapters && this.renderChapters()}
          {this.renderSlots(slots)}
        </ScrollView>
      </View>
    );
  }

  renderSlots = (slots) => {
    let { value } = this.props;
    let {
      recursive,
      pastRevisions,
      events,
      startAt,
      endAt,
      range,
      expandedDates,
      zoomedOut,
      fineZooming,
      loadingRevisions,
      fetchingInheritance,
      averageSpan,
      allRevisions,
    } = this.state;

    let chunking = "week";
    if (range > 120) {
      chunking = "month";
    }
    console.log(range, chunking);

    let minWidth = undefined;
    let zoomedInMinWidth = 20;
    if (!zoomedOut) minWidth = zoomedInMinWidth;
    if (!!fineZooming) {
      // when fineZooming == 100, maxWidth is 20
      // when fineZooming == 1, maxWidth is this.context.sizes.WIDTH / slots.length
      let minW = this.context.sizes.WIDTH / slots.length;
      let maxW = zoomedInMinWidth;
      let fineZoomingPerc = fineZooming / 100;
      console.log(minW, maxW, fineZoomingPerc);
      minWidth = (maxW - minW) * fineZoomingPerc;
      // minWidth = minW;
    }

    // effective width of one day-slot; below ~a badge width, individual
    // MomentBullets can't render legibly, so fall back to compact dots
    let slotWidth = this.context.sizes.WIDTH / slots.length;
    if (!!minWidth && minWidth > slotWidth) slotWidth = minWidth;
    let compact = slotWidth < this.DOT_SIZE + this.DOT_PADDING * 2;

    return (
      <View style={{ marginBottom: this.context.sizes.tiny }}>
        <View
          style={{ flexDirection: "row", ...StyleSheet.absoluteFillObject }}
        >
          {slots.map((item, index) => {
            let isExpanded = expandedDates.includes(item.date);
            let dow = timeHelpers.getDayOfWeek(item.date);
            let dom = timeHelpers.getDayOfMonth(item.date);
            let isEndOfMonth = false;
            if (chunking == "month") {
              if (timeHelpers.endOfMonth(item.date) == item.date) {
                isEndOfMonth = true;
              }
            }
            let isWeekend = ["Saturday", "Sunday"].includes(dow);
            let isWeekDay = true;
            if (chunking == "week" && isWeekend == true) {
              isWeekDay = false;
            }
            return (
              <View
                key={index}
                style={[
                  this.styles().timeSlot,
                  // !zoomedOut && { minWidth: 20 },
                  { minWidth },
                  // !!(index % 2) && !item.cushion && this.styles().timeSlotAlt,
                  !!(index % 2) && this.styles().timeSlotAlt,
                  isWeekDay && this.styles().timeSlotWeekday,
                  chunking == "week" &&
                    dow == "Monday" &&
                    this.styles().timeSlotMonday,
                  chunking == "week" &&
                    dow == "Friday" &&
                    this.styles().timeSlotFriday,
                  chunking == "month" &&
                    dom == 1 &&
                    this.styles().timeSlotMonday,
                  chunking == "month" &&
                    isEndOfMonth &&
                    this.styles().timeSlotFriday,
                  isExpanded && this.styles().expandedTimeSlot,
                  // !!expandedDates?.length &&
                  //   !isExpanded && { flexGrow: 0 },
                ]}
              />
            );
          })}
        </View>

        {compact ? (
          this.renderCompactSlots(slots, slotWidth, minWidth)
        ) : (
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            // ...StyleSheet.absoluteFillObject,
          }}
        >
          {slots.map((item, index) => {
            let events = item.events;
            let isExpanded = expandedDates.includes(item.date);
            return (
              <TouchableWithoutFeedback
                onPress={(e) =>
                  RootNavigation.push("Chapters", { date: item.date }, e)
                }
                key={index}
              >
                <Hoverable onHoverIn={() => null} onHoverOut={() => null}>
                  {(isHovered) => {
                    return (
                      <View
                        style={[
                          this.styles().timeSlot,
                          { minWidth },
                          // !!(index % 2) && this.styles().timeSlotAlt,
                          { zIndex: 999 - index },
                          isExpanded && this.styles().expandedTimeSlot,
                          // !!expandedDates?.length &&
                          //   !isExpanded && { flexGrow: 0 },
                          // isHovered && this.styles().timeSlotHover,
                          {
                            justifyContent: "space-around",
                          },
                          !!(index % 2)
                            ? { paddingTop: 20 }
                            : { paddingBottom: 20 },
                        ]}
                      >
                        {events.map((event, i) => {
                          return (
                            <View
                              key={event.event_id}
                              style={{ zIndex: 999 - i, flex: 1 }}
                            >
                              <MomentBullet
                                showIcon
                                smallBadge
                                moment={event}
                                category={event.category}
                                hideText
                                expanded={false}
                                stackTags
                                onExpand={() => this.expandSlot(item)}
                                onCollapse={() => this.collapseSlot(item)}
                                noteIcon
                                showTooltip
                                // noActions
                                tooltipText={this.tooltipText(event)}
                                tooltipOptions={{
                                  rightAligned:
                                    index > slots.length / 2 ? true : false,
                                  numberOfLines: 12,
                                  style: this.styles().storyTooltip,
                                }}
                                asyncMoment
                              />
                            </View>
                          );
                        })}
                        {(isHovered || isExpanded) && (
                          <View style={this.styles().slotTooltip}>
                            <Text center trim numberOfLines={1}>
                              |
                            </Text>
                            <TouchableOpacity
                              onPress={(e) => {
                                RootNavigation.push(
                                  "Chapters",
                                  { date: item.date },
                                  e,
                                );
                              }}
                            >
                              <Text center trim numberOfLines={1}>
                                {item.date}{" "}
                                {timeHelpers.getDayOfWeek(item.date)}
                              </Text>
                            </TouchableOpacity>
                          </View>
                        )}
                      </View>
                    );
                  }}
                </Hoverable>
              </TouchableWithoutFeedback>
            );
          })}
        </View>
        )}
      </View>
    );
  };

  // groups day-slots into buckets wide enough to fit a dot, and renders each
  // event as a clickable dot instead of a full MomentBullet
  renderCompactSlots = (slots, slotWidth, minWidth) => {
    let dotWidth = this.DOT_SIZE + this.DOT_PADDING * 2;
    let bucketSize = Math.ceil(dotWidth / slotWidth);
    let buckets = [];
    for (let i = 0; i < slots.length; i += bucketSize) {
      let group = slots.slice(i, i + bucketSize);
      buckets.push({
        startIndex: i,
        startDate: group[0].date,
        endDate: group[group.length - 1].date,
        events: group.reduce((all, s) => [...all, ...s.events], []),
        span: group.length,
      });
    }

    return (
      <View style={{ flex: 1, flexDirection: "row" }}>
        {buckets.map((bucket, index) => {
          let overflow = bucket.events.length - this.MAX_DOTS_PER_BUCKET;
          let visible =
            overflow > 0
              ? bucket.events.slice(0, this.MAX_DOTS_PER_BUCKET)
              : bucket.events;
          let rightAligned = index > buckets.length / 2;
          return (
            <Hoverable key={index} onHoverIn={() => null} onHoverOut={() => null}>
              {(isHovered) => (
                <View
                  style={{
                    flex: bucket.span,
                    minWidth: !!minWidth ? minWidth * bucket.span : undefined,
                    height: 100,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {visible.map((event) =>
                    this.renderEventDot(event, rightAligned),
                  )}
                  {overflow > 0 && (
                    <TouchableOpacity
                      onPress={() => this.zoomToSlot(bucket.startIndex)}
                    >
                      <HoverableTooltip
                        text={`${overflow} more — zoom in`}
                        rightAligned={rightAligned}
                      >
                        <Text trim style={{ fontSize: 10 }}>
                          +{overflow}
                        </Text>
                      </HoverableTooltip>
                    </TouchableOpacity>
                  )}
                  {isHovered && !!bucket.events.length && (
                    <View style={this.styles().slotTooltip}>
                      <TouchableOpacity
                        onPress={(e) => {
                          RootNavigation.push(
                            "Chapters",
                            { date: bucket.startDate },
                            e,
                          );
                        }}
                      >
                        <Text center trim numberOfLines={1}>
                          {bucket.startDate}
                          {bucket.endDate != bucket.startDate &&
                            ` – ${bucket.endDate}`}
                        </Text>
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
              )}
            </Hoverable>
          );
        })}
      </View>
    );
  };

  // One overlay for both dot popups, rendered on the timeline's ROOT so it
  // escapes the horizontal ScrollView's clipping and the slots' stacking
  // contexts: the hover story card (non-interactive) and the click-to-inspect
  // MomentBullet (interactive). Sits above the whole strip at the dot's x.
  showEventOverlay = (event, eventKey, mode) => {
    // locked popups are wider (they hold a working bullet); hover previews
    // stay narrow
    let width = mode == "inspect" ? 520 : 320;
    let apply = (left, bottom, effWidth) => {
      if (mode == "hover") {
        if (this.state.inspectedEvent) return; // don't fight the open bullet
        this.setState({
          hoveredEvent: event,
          hoveredEventKey: eventKey,
          overlayLeft: left,
          overlayBottom: bottom,
          overlayWidth: effWidth,
        });
      } else {
        this.setState({
          inspectedEvent: event,
          hoveredEvent: null,
          hoveredEventKey: null,
          overlayLeft: left,
          overlayBottom: bottom,
          overlayWidth: effWidth,
        });
      }
    };
    let ref = this[`dot-${eventKey}`];
    if (!ref?.measure || !this.rootRef?.measure)
      return apply(null, null, width);
    ref.measure((x, y, w, h, pageX, pageY) => {
      this.rootRef.measure((rx, ry, rw, rh, rootPageX, rootPageY) => {
        let maxW = rw || 800;
        let effWidth = Math.min(width, maxW - 8);
        let cx = (pageX || 0) - (rootPageX || 0) + (w || 0) / 2;
        let left = Math.max(4, Math.min(maxW - effWidth - 4, cx - effWidth / 2));
        // anchor the card's bottom just above THIS dot, not the whole strip
        let bottom =
          (rh || 0) - ((pageY || 0) - (rootPageY || 0)) +
          this.context.sizes.tiny;
        apply(left, bottom, effWidth);
      });
    });
  };

  // short label for the overlay header ("Created", "Progress · 3:04 PM"…)
  eventHeadline = (event) => {
    let headline = "";
    if (event.category == "creation") headline = "Created";
    else if (event.category == "completion") headline = "Completed";
    else if (event.category == "archive") headline = "Archived";
    else if (event.category == "note") headline = "Note";
    else if (event.category == "progress")
      headline = `${event.pin ? "Pinned" : "Progress"} · ${textHelpers.formatTime(
        event.timestamp,
      )}`;
    let dateStr = timeHelpers.dateTimeToDate(event.timestamp);
    return `${dateStr} ${timeHelpers.getDayOfWeek(dateStr) || ""} — ${headline}`;
  };

  renderTimelineOverlay = () => {
    let inspected = !!this.state.inspectedEvent;
    let event = this.state.inspectedEvent || this.state.hoveredEvent;
    if (!event) return null;
    let close = () =>
      this.setState({
        inspectedEvent: null,
        hoveredEvent: null,
        hoveredEventKey: null,
      });
    let bullet = (
      <MomentBullet
        // stance stripped so a moment saved as "expanded" elsewhere doesn't
        // auto-expand (and auto-fetch) in every hover preview
        moment={{ ...(event.moment || {}), stance: null, value: event.value }}
        onEscape={close}
      />
    );
    return (
      <View
        pointerEvents={inspected ? "auto" : "none"}
        style={{
          position: "absolute",
          bottom:
            this.state.overlayBottom != null
              ? this.state.overlayBottom
              : "100%",
          left: this.state.overlayLeft != null ? this.state.overlayLeft : 20,
          width: this.state.overlayWidth || 320,
          maxHeight: 440,
          zIndex: 9999,
          borderWidth: 1,
          borderColor: this.context.colors.trim,
          borderRadius: this.context.sizes.borderRadius,
          backgroundColor: this.context.colors.empty,
          padding: this.context.sizes.base,
          shadowColor: "#000",
          shadowOpacity: 0.15,
          shadowRadius: 8,
          shadowOffset: { width: 0, height: -3 },
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: this.context.sizes.tiny,
          }}
        >
          <Text
            numberOfLines={1}
            style={{
              color: this.context.colors.trim,
              fontSize: this.context.sizes.smallFont,
              flex: 1,
            }}
          >
            {this.eventHeadline(event)}
          </Text>
          {inspected && (
            <Text
              style={{
                color: this.context.colors.trim,
                paddingLeft: this.context.sizes.small,
              }}
              onPress={close}
            >
              ✕
            </Text>
          )}
        </View>
        {inspected ? (
          // expanding the bullet scrolls inside the popup instead of
          // growing it up to the top of the page
          <ScrollView nestedScrollEnabled style={{ maxHeight: 380 }}>
            {bullet}
          </ScrollView>
        ) : (
          <View style={{ maxHeight: 300, overflow: "hidden" }}>{bullet}</View>
        )}
      </View>
    );
  };

  renderEventDot = (event, rightAligned = false) => {
    let color = valueHelpers.getColor(event.value, this.context.colorScheme);
    let hollow = ["creation", "note", "archive"].includes(event.category);
    let small = ["progress", "note", "archive"].includes(event.category);
    let size = small ? this.DOT_SIZE * 0.6 : this.DOT_SIZE;
    let eventKey = event.event_id || event.id;
    let inspected =
      !!this.state.inspectedEvent &&
      (this.state.inspectedEvent.event_id ||
        this.state.inspectedEvent.id) == eventKey;
    return (
      <View key={eventKey} ref={(r) => (this[`dot-${eventKey}`] = r)}>
        <Hoverable
          onHoverIn={() => this.showEventOverlay(event, eventKey, "hover")}
          onHoverOut={() => {
            if (this.state.hoveredEventKey == eventKey)
              this.setState({ hoveredEvent: null, hoveredEventKey: null });
          }}
        >
          {() => (
            <TouchableOpacity
              onPress={() => {
                if (!event.value?.id) return;
                if (inspected) this.setState({ inspectedEvent: null });
                else this.showEventOverlay(event, eventKey, "inspect");
              }}
              style={{ padding: this.DOT_PADDING }}
            >
              <View
                style={{
                  width: size,
                  height: size,
                  borderRadius: 999,
                  backgroundColor: hollow ? "transparent" : color,
                  borderWidth: hollow ? 1.5 : 0,
                  borderColor: color,
                }}
              />
            </TouchableOpacity>
          )}
        </Hoverable>
      </View>
    );
  };

  zoomToSlot = async (index) => {
    await this.setState({ zoomedOut: false, fineZooming: 0 });
    // slots get a 20px min width once zoomed in; center the target slot
    setTimeout(() => {
      this.scrollRef?.scrollTo({
        x: Math.max(0, index * 20 - this.context.sizes.WIDTH / 2),
        animated: false,
      });
    }, 50);
  };

  renderChapters = () => {
    let { moments, chapters, chapterSlots, loadingChapters } = this.state;
    if (loadingChapters)
      return (
        <View
          style={{
            width: this.context.sizes.WIDTH,
            justifyContent: "center",
            alignItems: "center",
            height: 100,
          }}
        >
          <ActivityIndicator />
        </View>
      );
    // console.log(moments, chapters);
    return this.renderSlots(chapterSlots);
  };

  // A readable multi-line story card: date, what happened, and the moment's
  // actual body text so hovering the timeline reads like the story's beats
  tooltipText = (event) => {
    let { value } = this.props;
    let valueText = event.value?.title || event.value?.text || "";
    let otherValue = event.value?.id != value.id;

    let headline = "";
    if (event.category == "creation") {
      headline = otherValue ? `Created — ${valueText}` : "Created";
    } else if (event.category == "completion") {
      headline = otherValue ? `Completed — ${valueText}` : "Completed";
    } else if (event.category == "archive") {
      headline = otherValue ? `Archived — ${valueText}` : "Archived";
    } else if (event.category == "progress") {
      headline = event.pin ? "Pinned" : "Progress";
      headline += ` · ${textHelpers.formatTime(event.timestamp)}`;
      if (otherValue) headline += ` — ${valueText}`;
    } else if (event.category == "note") {
      headline = valueText;
    }

    // story text: the moment's body, or a child note/value's body
    let body = event.moment?.text || "";
    if (!body && otherValue && event.category != "note") {
      body = event.value?.text || "";
    }
    body = (body || "").trim();
    if (body.length > 300) body = `${body.slice(0, 300)}…`;

    let dateStr = timeHelpers.dateTimeToDate(event.timestamp);
    let lines = [
      `${dateStr} ${timeHelpers.getDayOfWeek(dateStr) || ""}`.trim(),
      headline,
    ].filter((l) => !!l?.length);
    if (!!body.length) lines.push("", body);
    return lines.join("\n");
  };

  expandSlot = (slot) => {
    let { expandedDates } = this.state;
    let date = slot.date;
    expandedDates.push(date);
    this.setState({ expandedDates });
  };

  collapseSlot = (slot) => {
    let { expandedDates } = this.state;
    let date = slot.date;
    let index = expandedDates.indexOf(date);
    if (index >= 0) {
      expandedDates.splice(index, 1);
      this.setState({ expandedDates });
    }
  };

  renderTitle = (value, timestampOnly = true) => {
    let text = null;
    let dt = null;
    // console.log(value);
    if (!!value.is_progress || !!value.is_note) {
      dt = timeHelpers.dateTimeToDate(value.completed_at || value.created_at);
      text = timestampOnly ? dt : dt;
    } else if (!!value.completed_at) {
      dt = timeHelpers.dateTimeToDate(value.completed_at);
      text = timestampOnly ? dt : `Completed at ${dt}`;
    } else {
      dt = timeHelpers.dateTimeToDate(value.created_at);
      text = timestampOnly ? dt : `Created at ${dt}`;
    }
    if (!!text) {
      // return <Text button>{text}</Text>;
      return <Text>{text}</Text>;
    }
    return null;
  };

  fetchInheritance = async () => {
    let { value } = this.props;
    let { descendantLevelsDeep } = this.state;
    if (!this.state.recursive) return;
    this.setState({ fetchingInheritance: true });
    let res = await valueActions.getFamily(value.id, {
      up: 0,
      down: descendantLevelsDeep,
    });
    console.log("DESCENDANT RES", res);
    this.setState({ fetchingInheritance: false });
  };

  styles = () => ({
    contentRow: {
      // no flex: with flex-basis 0 the strip contributed ~nothing to the
      // page's natural scroll height — it painted via overflow but the
      // ScrollView couldn't scroll to it (worst in Narrative mode)
      marginTop: sizes.giant,
      // marginBottom: sizes.giant,
      marginHorizontal: sizes.base,
      alignSelf: "stretch",
      // alignItems: "stretch",
      // zIndex: -1,
      // minHeight: HEIGHT / 3,
      // minHeight: (HEIGHT - 110 - 243 - 60) / 2,
      alignItems: "center",
      // borderWidth: 2,
      borderColor: "red",
      // minHeight: 200,
    },
    header: {
      flexDirection: "row",
      alignSelf: "stretch",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: sizes.base,
    },
    headerSection: {
      flexDirection: "row",
      alignItems: "center",
    },
    timeline: {
      flexDirection: "row",
      alignItems: "center",
      alignSelf: "stretch",
    },
    line: {
      flex: 1,
      height: 1,
      backgroundColor: this.context.colors.trim,
    },
    timeSlot: {
      flex: 1,
      // flexGrow: 1,
      // flexShrink: 0,
      // minWidth: 30,
      justifyContent: "center",
      alignItems: "center",
      height: 100,
      borderColor: this.context.colors.trim,
    },
    timeSlotAlt: {
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.trim,
        0.3,
      ),
    },
    timeSlotWeekday: {
      borderBottomWidth: 1,
      borderTopWidth: 1,
    },
    timeSlotMonday: {
      borderLeftWidth: 1,
    },
    timeSlotFriday: {
      borderRightWidth: 1,
    },
    timeSlotHover: {
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.trim,
        0.9,
      ),
    },
    expandedTimeSlot: {
      minWidth: 250,
      justifyContent: "flex-start",
      alignItems: "flex-start",
      // borderWidth: 1,
      borderColor: "green",
    },
    slotTooltip: {
      position: "absolute",
      top: "100%",
      // top: 0,
      // left: 0,
    },
    // wide, high-contrast card so hovering a bullet reads like a story beat.
    // Opens UPWARD: the timeline sits at the bottom of the screen, so the
    // default below-the-element placement hangs off-screen.
    storyTooltip: {
      width: 280,
      // "auto" (not undefined) — undefined doesn't override the base
      // top:150% in RN-web's style flatten, which left the card pinned
      // by both edges and squashed
      top: "auto",
      bottom: "130%",
      backgroundColor: this.context.colors.empty,
      borderWidth: 1,
      borderColor: this.context.colors.trim,
      padding: this.context.sizes.base,
      shadowColor: "#000",
      shadowOpacity: 0.15,
      shadowRadius: 8,
      shadowOffset: { width: 0, height: -3 },
    },
  });
}
